<template>
	<AppLayout :title="trans('general.version.title')">
		<div class="grow flex flex-col items-center justify-center gap-6">
			<img class="size-[200px] rounded-2xl" :src="logo" :alt="`${version} Logo`">
			<p class="text-4xl font-bold text-pink-400 dark:text-pink-600">{{ version }}</p>
			<Card :title="serverTime" :subtitle="trans('general.special_thanks')">
				<List>
					<ListItem title="María Belén Frank"/>
					<ListItem title="Lucía Manochio Piccioni"/>
					<ListItem title="consuelo"/>
					<ListItem title="iara micciullo"/>
					<ListItem title="paz ramirez"/>
					<ListItem title="Agustín Gras Pirillo"/>
					<ListItem title="Lucas Gervasoni"/>
					<ListItem title="Bernardo Miguel Strupp"/>
					<ListItem title="Fabricio Boguais"/>
					<ListItem title="Felicitas Marcenac"/>
					<ListItem title="Giovanni María Camuz Ligios"/>
					<ListItem title="María Iveth Sosa Carballo"/>
					<ListItem title="Guillermina Mir López"/>
				</List>
			</Card>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import Card from '@/Components/Cards/Card.vue'
import List from '@/Components/Lists/List.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import ListItem from '@/Components/Lists/ListItem.vue'

defineProps<{
	logo:string,
	version:string,
	serverTime:string,
}>()
</script>